import { render, staticRenderFns } from "./serviceOrderConfirm.vue?vue&type=template&id=28313d51&"
import script from "./serviceOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./serviceOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./serviceOrderConfirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports